var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useState } from 'react';
import { Form, FormSpy } from 'react-final-form';
import { Button } from '@mui/material';
import classNames from 'classnames';
import isEmpty from 'lodash/isEmpty';
import { SML_SIZE } from '../../constants/common';
import InputHelpText from '../InputHelpText';
import LoadingButton from '../mui/LoadingButton';
import FieldRenderer from './FieldRenderer';
var FormBuilder = function (_a) {
    var schema = _a.schema, initialValues = _a.initialValues, validate = _a.validate, onSecondaryClick = _a.onSecondaryClick, onSubmit = _a.onSubmit, _b = _a.loading, loading = _b === void 0 ? false : _b, error = _a.error, loadOptions = _a.loadOptions, checkConditionalRender = _a.checkConditionalRender, formRef = _a.formRef, submitRef = _a.submitRef, _c = _a.size, size = _c === void 0 ? SML_SIZE.S : _c, onChange = _a.onChange, externalErrors = _a.externalErrors, _d = _a.className, className = _d === void 0 ? '' : _d, _e = _a.actionsContainerClassName, actionsContainerClassName = _e === void 0 ? '' : _e, _f = _a.hideActions, hideActions = _f === void 0 ? false : _f, _g = _a.editable, editable = _g === void 0 ? false : _g, _h = _a.ctaDisabled, ctaDisabled = _h === void 0 ? false : _h, _j = _a.persistInitialValues, persistInitialValues = _j === void 0 ? false : _j;
    var formBuilderSubmit = function (values) {
        onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit(values);
    };
    var _k = __read(useState(initialValues), 2), internalInitialValues = _k[0], setInternalInitialValues = _k[1];
    useEffect(function () {
        if (!persistInitialValues || !internalInitialValues || isEmpty(internalInitialValues)) {
            setInternalInitialValues(initialValues);
        }
    }, [initialValues]);
    return (React.createElement(Form, { onSubmit: formBuilderSubmit, validate: validate, initialValues: internalInitialValues }, function (_a) {
        var form = _a.form, handleSubmit = _a.handleSubmit;
        if (formRef) {
            formRef.current = form;
        }
        if (submitRef) {
            submitRef.current = handleSubmit;
        }
        return (React.createElement("form", { 
            // eslint-disable-next-line @typescript-eslint/no-misused-promises
            onSubmit: handleSubmit, className: classNames('lfc-p-[16px] lfc-pb-0', schema.className, className) },
            React.createElement(FieldRenderer, { inputs: schema.inputs, formEditable: editable, size: size, loadOptions: loadOptions, checkConditionalRender: checkConditionalRender, externalErrors: externalErrors }),
            error && (React.createElement(InputHelpText, { helpTextType: "error", text: error, size: size, className: "lfc-col-span-full lfc-flex-grow" })),
            !hideActions && (React.createElement("div", { className: classNames('lfc-col-span-full lfc-flex lfc-gap-[8px] lfc-mt-[8px] lfc-mx-[-16px] lfc-p-[12px_16px] lfc-shadow-[0px_-2px_12px_4px_rgba(0,0,0,0.16)] lfc-w-[calc(100%+32px)]', actionsContainerClassName) },
                !!schema.secondaryButtonText && (React.createElement(Button, { variant: "outlined", className: "lfc-flex-grow", onClick: onSecondaryClick, disabled: loading || ctaDisabled }, schema.secondaryButtonText)),
                loading ? (React.createElement(LoadingButton, { className: "lfc-flex-grow" })) : (React.createElement(Button, { variant: "contained", color: "primary", className: classNames('lfc-flex-grow', {
                        'lfc-bg-blue-500': !ctaDisabled
                    }), 
                    // eslint-disable-next-line @typescript-eslint/no-misused-promises
                    onClick: handleSubmit, disabled: ctaDisabled }, schema.primaryButtonText || 'Submit')))),
            onChange && React.createElement(FormSpy, { subscription: { values: true }, onChange: onChange })));
    }));
};
export default FormBuilder;
//# sourceMappingURL=FormBuilder.js.map